import Vue from 'vue';
import jQuery from 'jquery';
// Explicitly load the jQuery plugin so `$.fn.datetimepicker` is registered on the
// same jQuery instance used here, regardless of bundler module ordering.
import 'pc-bootstrap4-datetimepicker';
import DatePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

// Defensive: if the jQuery plugin failed to register (e.g. incompatible jQuery
// version), don't crash the whole app — just skip the custom icon defaults.
if (jQuery.fn.datetimepicker && jQuery.fn.datetimepicker.defaults) {
  jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle'
    }
  });
} else {
  // eslint-disable-next-line no-console
  console.warn(
    '[datepicker] $.fn.datetimepicker is not available — skipping default icon config. ' +
      'Check that jQuery is v3 (pc-bootstrap4-datetimepicker does not support jQuery 4).'
  );
}

Vue.use(DatePicker);
